module.exports = __webpack_public_path__ + "static/img/edit-account.3d13542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/edit-account.jpg
// module id = 4kgB
// module chunks = 1